import { EmotionIconProps } from '@emotion-icons/emotion-icon'

export const TradeAreaIcon = (props: EmotionIconProps) => {
  const { fill, color, size } = props
  return (
    <svg height={size} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.73992 9.20021L11.0549 5.30775L15.685 5.30775L18 9.20021L15.685 13.0927H11.0549L8.73992 9.20021Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        d="M0 4.30544L2.44157 0.200196L7.32472 0.200195L9.76629 4.30544L7.32472 8.41068L2.44157 8.41068L0 4.30544Z"
        fill={fill || color || 'currentColor'}
      />
      <path
        d="M0 14.095L2.44157 9.98971H7.32472L9.76629 14.095L7.32472 18.2002H2.44157L0 14.095Z"
        fill={fill || color || 'currentColor'}
      />
    </svg>
  )
}
